import React from 'react';
import KeywordAvatar from '../ContentKeywordTable/KeywordAvatar';

export interface HeadCellSecondaryIconProps {
  children?: React.ReactNode;
  align?: 'left' | 'right';
}

const HeadCellSecondaryIcon: React.FC<HeadCellSecondaryIconProps> = ({ children, align = 'right' }) => {

  return (
    <div className={`flex flex-row gap-2 items-center flex-nowrap ${align === 'left' ? 'justify-start' : 'justify-end'}`}>
      <KeywordAvatar index={1} size='sm' />
      <div>{children}</div>
    </div>
  );
};

export default HeadCellSecondaryIcon;
